import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'

const ErrorInfo = (props) => {
  if (props.enabled) {
    const isHidden = (props.errors.length === 0) ? 'hide' : ''

    return (
      <div className={`input-error-info m-t-sm ${isHidden}`}>
        <ul>
          {
            props.errors.map((value, index) => {
              const field = intl.get(`account.${props.field}`)
              return (
                <li key={index}>{intl.get(`validations.${value}`, { field })}</li>
              )
            })
          }
        </ul>
      </div>
    )
  }

  return null
}

ErrorInfo.propTypes = {
  enabled: PropTypes.bool,
  field: PropTypes.string.isRequired,
  errors: PropTypes.array.isRequired,
}

export default ErrorInfo
